<template>
  <div class="date-range-filter">
    <!-- 时间类型选择 -->
    <el-select
      v-if="typeOptions.length"
      v-model="internalType"
      :placeholder="$t('sc.afterSaleNew.all')"
      class="type-select"
    >
      <el-option
        v-for="item in typeOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>

    <div class="shortcut-btns">
      <el-button
        v-for="(item, index) in timeList"
        :key="'date_range_' + index"
        :type="shortcut === item.value ? 'primary' : ''"
        :class="{ 'no-check-btn': shortcut !== item.value }"
        plain
        @click="handleDateRangeChange(item.value)"
      >
        {{ item.label }}
      </el-button>
    </div>

    <el-date-picker
      v-model="internalValue"
      type="daterange"
      range-separator="-"
      value-format="yyyy-MM-dd"
      class="date-picker-div"
      v-bind="$attrs"
      @change="handleDateChange"
    />
  </div>
</template>

<script>
export default {
  name: 'DateRangeFilter',
  props: {
    // 选中的日期范围 [startDate, endDate]
    value: {
      type: Array,
      default: () => []
    },
    // 当前选中的快捷键值
    shortcut: {
      type: [Number, String],
      default: ''
    },
    // 时间类型值
    type: {
      type: String,
      default: ''
    },
    // 时间类型选项 [{label: '', value: ''}]
    typeOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit('input', val || [])
      }
    },
    internalType: {
      get() {
        return this.type
      },
      set(val) {
        this.$emit('update:type', val)
        this.$emit('type-change', val)
      }
    },
    timeList() {
      return [
        {
          label: this.$t('sc.afterSaleNew.days7'),
          value: 7
        },
        {
          label: this.$t('sc.afterSaleNew.days30'),
          value: 30
        },
        {
          label: this.$t('sc.afterSaleNew.MTD'),
          value: 'MTD'
        },
        {
          label: this.$t('sc.afterSaleNew.YTD'),
          value: 'YTD'
        },
        {
          label: this.$t('sc.afterSaleNew.TD'),
          value: 'TD'
        }
      ]
    }
  },
  watch: {
    shortcut: {
      handler(val) {
        if (val) {
          const dateRange = this.getRangeDates(val)
          this.$emit('input', dateRange)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 根据快捷键获取日期范围
    getRangeDates(range) {
      const today = new Date()
      let startDate = new Date()
      if (range === 7) {
        startDate.setDate(today.getDate() - 6)
      } else if (range === 30) {
        startDate.setDate(today.getDate() - 29)
      } else if (range === 'MTD') {
        startDate = new Date(today.getFullYear(), today.getMonth(), 1)
      } else if (range === 'YTD') {
        startDate = new Date(today.getFullYear(), 0, 1)
      } else if (range === 'TD') {
        startDate = today
      }
      return [
        this.$tz.formatDate(startDate, 'yyyy-MM-dd'),
        this.$tz.formatDate(today, 'yyyy-MM-dd')
      ]
    },
    // 日期范围单选按钮改变
    handleDateRangeChange(range) {
      this.$emit('update:shortcut', range)
      const dateRange = this.getRangeDates(range)
      this.$emit('input', dateRange)
      this.$emit('change', dateRange)
    },
    // 日期改变
    handleDateChange(val) {
      this.$emit('update:shortcut', '')
      this.$emit('change', val || [])
    }
  }
}
</script>

<style lang="scss" scoped>
.date-range-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .type-select {
    width: 160px;
    margin-right: 12px;
  }
  .shortcut-btns {
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .date-picker-div {
    width: 240px;
  }
  .no-check-btn {
    color: #666666;
    border: 1px solid #fff;
    &:hover {
      color: $color-default-background;
      background-color: transparent !important;
    }
  }
}
</style>
